import { WHATSAPP } from "../constants/testIds";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const number = "584121496804";
  const msg = encodeURIComponent("Hola Delcielo Tech, me gustaría conocer más.");
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      data-testid={WHATSAPP}
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#FF8C00] text-white shadow-2xl animate-pulse-ring hover:scale-105 transition-transform"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
